module.exports = "<aside id=\"right-panel\" class=\"shop-rightPanel\" tabindex=\"-1\" ng-if=\"$breakpoints.isInGreaterThanMediumFormatLandscape\">\r\n    <wow-cart-offscreen></wow-cart-offscreen>\r\n</aside>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/views/right-panel.view.html
// module id = 17
// module chunks = 0